export class ViewModelFiltroWebBloqueioExcecao {
    idSeq: number
    idFuncionalidade: number
    idPlano: number
    idPlanoCategoria: number
    idPlanoSituacao: number
    idPessoa: number
    nrMatricula: string
    icBloqueio: string
    dataBloqueio: Date
    nmMensagem: string
    nmFuncionalidade: string
    nmPlano: string
    nmPlanoCategoria: string
    nmPlanoSituacao: string
    nmPessoa: string
}